import { IPreferenceCustomizacao, IPreferenceLayoutPDF, typeAbas } from "@monorepo-web/logic-extrato";
import { DecodificaNomePagina, defaultLayoutPages } from "./DefaultLayoutPages";
import { ComponentPDF, funcoesPDF } from "@monorepo-web/pdf-generator";
import { docJSPDF, IConfig } from '@monorepo-web/pdf-generator';

/**
 * Gerar as configurações de cada componente do PDF, utilizando o layout das páginas
 */
export class StructurePDF {
  docObj: docJSPDF;
  layoutPaginasPDF: typeAbas[];
  private configPerPage: Record<string, string[]>;  // armazena por página um array com os ids dos componentes

  constructor(docObj: docJSPDF, layoutPaginasPDF: typeAbas[]) {
    this.docObj = docObj;
    this.layoutPaginasPDF = layoutPaginasPDF;
    this.configPerPage = {};
  }

  /**
   * Cria componentPDF para o título da página
   * @param nomePagina Título da página
   * @returns ComponentPDF com o título
   */
  private gerarTituloPagina(nomePagina: string) {
    const tituloComEstilo = this.docObj.criarTituloPagina(DecodificaNomePagina[nomePagina as typeAbas]);
    return funcoesPDF.gerarTexto(tituloComEstilo, { level: 0 });
  }

  /**
   * Considera as customizações da preference_whitelabel para verificar se deve remover tabelas e gráficos
   * @param configs Configurações dos componentes que serão utilizados no PDF
   * @param preferenceCustomizacao
   */
  private processPreferenceCustomizacao(configs: Record<string, IConfig>, preferenceCustomizacao: IPreferenceCustomizacao | null){
    // remove gráfico Alocação Custodiante
    if(!(preferenceCustomizacao?.ResCart_mostrarGraficoAlocacao ?? true) && configs.graficoCustodiante){
      delete configs.graficoCustodiante;
    }
    // Remove gráfico Evolução do Patrimônio
    if(preferenceCustomizacao?.PerfHist_removerGrafEvPatrimonio && configs.EvolucaoPatrimonio){
      delete configs.EvolucaoPatrimonio;
    }
  }

  /**
   * Gera as configurações para os componentes que serão utilizados no PDF (ex: coordenada x, largura)
   * @param preferenceLayoutPDF Estrutura das páginas no PDF
   * @param preferenceCustomizacao
   * @returns Objeto com a configuração dos componentes do PDF
   */
  public getConfig(preferenceLayoutPDF: IPreferenceLayoutPDF | null, preferenceCustomizacao: IPreferenceCustomizacao | null) {
    let configs: Record<string, IConfig> = {};
    for (const pagina of this.layoutPaginasPDF) {
      const layoutPage = preferenceLayoutPDF?.[pagina as keyof typeof preferenceLayoutPDF] ?? defaultLayoutPages[pagina];
      if (layoutPage) {
        const config = funcoesPDF.processaLayout(layoutPage, this.docObj.width, this.docObj.MARGIN_LEFT_RIGHT);
        if (config) {
          // guarda array com os ids dos componentes dessa página
          this.configPerPage[pagina] = config.map(item => item.id);

          // transforma array de configurações em um objeto, com o id do componente como chave
          const objConfig = config.reduce<Record<string, IConfig>>((acc, item) => {
            acc[item.id] = item;
            return acc;
          }, {});
          configs = { ...configs, ...objConfig };
        }
      }
    }
    this.processPreferenceCustomizacao(configs, preferenceCustomizacao);
    return configs;
  }

  /**
   * Organiza os components para seguir a ordem das páginas
   * @param components Objeto com todos os ComponentPDF que serão utilizados no PDF
   * @returns Array para cada página com os componentes organizados de acordo com o layout
   */
  public processComponents(components: Record<string, ComponentPDF | ComponentPDF [] | null>) {
    const componentsSorted = [];
    for (const [page, ComponentsId] of Object.entries(this.configPerPage)) {
      const pageComponents = [];
      for (const id of ComponentsId) {
        const component = components[id];
        if (component) {
          pageComponents.push(...(Array.isArray(component) ? component : [component]));
        }
      }
      if (pageComponents.length) {
        // adiciona o título da página e seus componentes
        componentsSorted.push([this.gerarTituloPagina(page), ...pageComponents]);
      }
    }
    return componentsSorted;
  }
}
